import type { RoutePath } from '@/lib/api-types'
import { formatTokenAmount, formatUsd } from '@/lib/format'

/**
 * The pools a finished swap went through, one compact line per path: the
 * pools in order, the path's share of the swap when there is more than one,
 * what came out at the end and its dollar value (John, Nov 2 2026: "the SOL
 * pool or AMD pool, Meteora, PumpSwap"; the shares add up to 100). Nothing
 * when the record has no route.
 */
export function RouteLine({ route, className = '' }: { route: RoutePath[] | null | undefined; className?: string }) {
  if (!route || route.length === 0) return null
  return (
    <div className={`text-xs ${className}`}>
      <div className="mb-1 font-medium">Route</div>
      <ul className="grid gap-0.5">
        {route.map((path, index) => (
          <li key={`${path.hops.map((hop) => hop.venue).join('-')}-${index}`} className="flex flex-wrap items-center gap-x-1.5 text-muted">
            {path.hops.map((hop, hopIndex) => (
              <span key={`${hop.venue}-${hop.pair}-${hopIndex}`} className="flex items-center gap-x-1.5">
                {hopIndex > 0 ? <span aria-hidden="true">→</span> : null}
                <span className="text-text">{hop.venue}</span>
                <span>{hop.pair}</span>
              </span>
            ))}
            {route.length > 1 ? <span>{path.percent}%</span> : null}
            {path.amountUi !== null && path.symbol ? (
              <span className="tabular-nums">
                {formatTokenAmount(path.amountUi, path.symbol)} {path.symbol}
              </span>
            ) : null}
            {path.usd !== null ? <span className="tabular-nums">{formatUsd(path.usd)}</span> : null}
          </li>
        ))}
      </ul>
    </div>
  )
}
